<template>
  <div class="root">
    <div class="root-title">热门供应</div>
    <div class="supply-view" v-for="(item, index) in supply" :key="index">
        <div class="left" style="flex:8;" >
            <div class="category-view"
                :style="{backgroundImage:'url('+item.imageUrl+')'}">
                <div class="title">{{item.category}}</div>
                <div class="subTitle">{{item.description}}</div>
            </div>
            <div class="category-view-info">
                <div class="info-row-1">
                    <div class="left-category" v-for="(categoryItem, categoryIndex) in item.categoryData1" :key="categoryIndex">
                        <div class="category-name" >
                            <div class="name" @click="categoryItemClick(categoryItem.categoryName)">{{categoryItem.categoryName}}</div>
                        </div>
                        <ul class="category-row" >
                            <li v-for="(category, i) in categoryItem.categoryItemList" :key="i">
                                <h4 class="h4" @click="categoryItemClick(category)">{{category}}</h4>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="info-row-2">
                    <div class="left-category" v-for="(categoryItem, categoryIndex) in item.categoryData2" :key="categoryIndex">
                        <div class="category-name" >
                            <div class="name" @click="categoryItemClick(categoryItem.categoryName)">{{categoryItem.categoryName}}</div>
                        </div>
                        <ul class="category-row" >
                            <li v-for="(category, i) in categoryItem.categoryItemList" :key="i">
                                <h4 class="h4" @click="categoryItemClick(category)">{{category}}</h4>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="right" style="flex:7;">
            <div class="right-view-left" style="flex:4;">
                <div class="title">好货推荐</div>
                <div class="goods-view">
                    <div class="goods" v-for="(good, i) in item.goods" :key="i" @click="toProductDetail(good.typeId, good)">
                        <img :src="good.image" alt="">
                        <div class="price-view">
                            <div class="price">{{good.price}}</div>
                            <div class="price-unit">{{good.unit}}</div>
                            <div class="num">成交{{good.num}}</div>
                        </div>
                        <div class="goodTitle">{{good.goodTitle}}</div>
                        <div class="margin">保证金{{good.margin}}元</div>
                        <div class="vip">
                            <!-- vip 质保两年 -->
                            <img src="https://image.cnhnb.com/supply/icon/vip_y3.png"  style="height: 12px;width:auto;margin-left:0px;">
                            <img src="https://image.cnhnb.com/supply/icon/bao.png" style="height: 12px;width:auto;margin-left:0px;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-view-right" style="flex:3;">
                 <div class="title">推荐供应商</div>
                 <div class="supplier-view" v-for="(supplier, i) in item.suppliers" :key="i">
                    <div class="dot"></div>
                    <div class="supplier" @click="toStore(supplier.typeId, supplier.shopId)">{{supplier.shopName}}</div>
                 </div>
            </div>
        </div>
    </div>
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%">
        <span>{{dialogTitle}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确定</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import {mapMutations, mapGetters} from 'vuex'
import {
    getTypeList, getProductList, getShopList
} from '@/api/home/supply.js'

export default {
  props: ['afterSaleList', 'page', 'total'],
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '',
      supply: [{
        category: '蔬菜',
        description: '品种丰富，以质论价',
        imageUrl: 'https://image.cnhnb.com/image/png/miniapp/2021/01/18/e3f7008104ae4f3d8edbbdf70e6bdefe.png',
        categoryData1: [
            {
                categoryName: '葱姜蒜类',
                categoryItemList: ['韭黄', '蒜苗', '大蒜', '生姜', '大葱', '小葱', '蒜苔', '洋葱', '藠头', '洋姜'],
            },
            {
                categoryName: '叶菜类',
                categoryItemList: ['白菜', '小白菜', '生菜', '苋菜', '娃娃菜', '木耳菜', '香菜', '油麦菜', '空心菜', '菠菜'],
            },
            {
                categoryName: '茄果菜类',
                categoryItemList: ['辣椒', '西红柿', '茄子', '秋葵', '鲜玉米', '玉米笋'],
            }
        ],
        categoryData2: [
            {
                categoryName: '根筋菜类',
                categoryItemList: ['鲜百合', '芦笋', '萝卜', '胡萝卜', '竹笋', '葛根', '魔芋', '木薯', '凉薯', '山药'],
            },
            {
                categoryName: '菌',
                categoryItemList: ['毛豆', '刀豆', '四季豆', '豆角', '扁豆', '豌豆', '荷兰豆', '四棱豆', '白玉豆', '狗爪豆'],
            },
            {
                categoryName: '食用菌',
                categoryItemList: ['松树菌', '元蘑', '珊瑚菌', '鹿茸菇', '栗蘑', '龙爪菇', '荷灵菇', '海鲜菇', '毛尖蘑', '姬菇'],
            }
        ],
        goods: [{
            image: 'https://image.cnhnb.com/image/jpeg/head/2020/11/21/ac74318e30db4e409b6d3f7da1fb6f70.jpeg?imageView2/1/w/525/h/525/format/jpg/interlace/1/quality/100/ignore-error/1',
            price: '1.50',
            unit: '元/斤',
            num: '',
            goodTitle: '费县硬粉西红柿大量上市，货源充足。个头均匀，颜色好。',
            margin: '1000'
        }, {
            image: 'https://image.cnhnb.com/image/jpeg/head/2021/08/07/458fab3d7b294c699fef05b1100134cb.jpeg?imageView2/1/w/525/h/525/format/jpg/interlace/1/quality/100/ignore-error/1',
            price: '0.80',
            unit: '元/斤',
            num: '',
            goodTitle: '香葱产地直供，常年有货，货源充足，价格美丽',
            margin: '2000'
        }],
        suppliers: [{
            'shopId': '',
            'shopName': '家香宝蒜业'
            }, {
                'shopId': '',
                'shopName': '湖北潜江众鼎小龙虾西兰花合作社'
            }, {
                'shopId': '',
                'shopName': '金乡诚信蒜业'
            }, {
                'shopId': '',
                'shopName': '专业西瓜蔬菜'
            }, {
                'shopId': '',
                'shopName': '荣生农副产品购销部'
            }, {
                'shopId': '',
                'shopName': '子宽鲜蔬菜店铺'
            }, {
                'shopId': '',
                'shopName': '鲜加安基地菜'
            }
        ]
      }, {
        category: '粮油米面',
        description: '产地直发，海量供应',
        imageUrl: 'https://image.cnhnb.com/image/png/miniapp/2021/01/18/f005688eea0945038e3cff0d2c1ec5e4.png',
        categoryData1: [
            {
                categoryName: '加工产品',
                categoryItemList: ['面', '米', '油'],
            },
            // {
            //     //, '火麻油', '亚麻籽油'
            //     categoryName: '食用油',
            //     categoryItemList: ['牛油果油', '山茶油', '花生油', '橄榄油', '玉米油', '菜籽油', '葵花籽油', '色拉油'],
            // },
            // {
            //     categoryName: '香辛料',
            //     categoryItemList: ['桂子', '千里香', '莳萝子', '胡椒粉', '杜松子', '百里香', '干辣椒', '辣椒粉', '胡椒', '孜然'],
            // },
            // {
            //     categoryName: '豆制品',
            //     categoryItemList: ['霉豆渣', '豆豉', '豆腐', '香干', '腐乳', '千张', '兰花干', '素鸡', '腐竹', '豆腐皮'],
            // }
        ],
        categoryData2: [
            // {
            //     categoryName: '调味品',
            //     categoryItemList: ['菌油', '味精', '鸡精', '糖', '醋', '酱油', '蚝油', '调味酱', '剁椒', '调味油'],
            // },
            // {
            //     categoryName: '谷物粉淀粉',
            //     categoryItemList: ['淀粉', '面粉', '粘米粉', '黄豆面', '燕麦粉', '马蹄粉', '高粱面粉', '玉米面', '豆面', '红豆粉'],
            // },
            // {
            //     categoryName: '面食米食',
            //     categoryItemList: ['饽饽', '凉糕', '肠粉', '锅贴', '西米', '馒头', '焖子', '面条', '饺子', '汤圆'],
            // }
        ],
        goods: [{
            image: 'https://image.cnhnb.com/image/jpg/head/2022/04/23/61dd7d3da6e640f4a99dcb48d6cbf1ef.jpg?imageView2/1/w/525/h/525/format/jpg/interlace/1/quality/100/ignore-error/1',
            price: '10.00',
            unit: '元/斤',
            num: '1209.2元',
            goodTitle: '云南彝族手工叶子红糖 价格实惠 无中间商差价',
            margin: '2000'
        }, {
            image: 'https://image.cnhnb.com/image/jpg/head/2023/04/13/13159cecbc9c4e13acb74c17f7fce43d.jpg?imageView2/1/w/525/h/525/format/jpg/interlace/1/quality/100/ignore-error/1',
            price: '118.00',
            unit: '元/袋',
            num: '1.2万',
            goodTitle: '食品级红糖 农业水产养殖红糖 培菌发酵EM菌红糖',
            margin: '2000'
        }],
        suppliers: [{
            'shopId': '',
            'shopName': '宜都市金十里生态农业专业合作社'
            }, {
                'shopId': '',
                'shopName': '江门市新会区御之品柑普茶有限公司'
            }, {
                'shopId': '',
                'shopName': '依安县名轩粮贸有限公司'
            }, {
                'shopId': '',
                'shopName': '开封开翔薯业农副产品'
            }, {
                'shopId': '',
                'shopName': '林跃峰胡椒调料商行'
            }, {
                'shopId': '',
                'shopName': '盘山县太平街道孙娇河蟹店'
            }, {
                'shopId': '',
                'shopName': '内蒙古大厚山农产品团购批发'
            }
        ]
      }, {
        category: '农副加工',
        description: '产地直发，海量供应',
        imageUrl: 'https://image.cnhnb.com/image/png/miniapp/2021/01/18/37e45ca73585463f92e56e8cd3087695.png',
        categoryData1: [
            {
                categoryName: '加工产品',
                categoryItemList: ['糖', '汤', '菌', '休闲食品', '蜜', '其他'],
            },
            // {
            //     categoryName: '干果坚果',
            //     categoryItemList: ['柿饼', '红枣', '枸杞', '核桃', '瓜子', '板栗', '葡萄干', '桂圆干', '山楂干', '白果'],
            // },
            // {
            //     categoryName: '肉制品加工',
            //     categoryItemList: ['熟羊肉', '火腿', '腊肉', '板鸭', '肉卷', '腌/咸鸭', '腌/咸肉', '腌/咸鹅', '腌/咸鸡', '烧鸡'],
            // },
            // {
            //     categoryName: '营养滋补',
            //     categoryItemList: ['蜂蜜', '花粉', '桃胶', '雪燕', '皂角米', '鱼鳔', '蜂王浆'],
            // }
        ],
        categoryData2: [
            // {
            //     categoryName: '茶叶',
            //     categoryItemList: ['黑茶', '普洱', '乌龙茶', '绿茶', '红茶', '花草茶', '黄茶', '白茶', '茶粉'],
            // },
            // {
            //     categoryName: '水产加工',
            //     categoryItemList: ['籽乌干', '章鱼干', '鱼鳞干', '鱿鱼干', '腌/咸螺', '蚬子干', '腌/咸鱼', '虾仁', '虾皮', '虾干'],
            // },
            // {
            //     categoryName: '速食品',
            //     categoryItemList: ['速冻蔬果', '饼干糕点', '蜜饯果脯', '休闲零食', '罐头', '方便食品', '糖果', '丸滑类', '冲饮'],
            // }
        ],
        goods: [{
            image: 'https://image.cnhnb.com/image/png/head/2020/09/22/66f998562699455c92ec5cba43ff380b.png?imageView2/1/w/525/h/525/format/jpg/interlace/1/quality/100/ignore-error/1',
            price: '68.00',
            unit: '元/斤',
            num: '1098.6元',
            goodTitle: '蓝莓果脯  含有大量花青素，保护眼睛视力，世界水果之 王',
            margin: '2000'
        }, {
            image: 'https://image.cnhnb.com/image/jpg/head/2021/08/09/c40be9546c71435bb33a3fc8234b5d8c.jpg?imageView2/1/w/525/h/525/format/jpg/interlace/1/quality/100/ignore-error/1',
            price: '3.80',
            unit: '元/袋',
            num: '2803.3元',
            goodTitle: '大鱿鱼干碳烤原味鱿鱼鱿鱼干海鲜干货水产批发',
            margin: '2000'
        }],
        suppliers: [
            {'shopId': '', 'shopName': '董记农家土特产'},
            {'shopId': '', 'shopName': '诚源茶叶凤庆滇红'},
            {'shopId': '', 'shopName': '中宁县杞通枸杞商行'},
            {'shopId': '', 'shopName': '小吴茶树菇种植基地'},
            {'shopId': '', 'shopName': '苏老五梨膏糖'},
            {'shopId': '', 'shopName': '绿色农业产品'},
            {'shopId': '', 'shopName': '沂蒙山产地药材店'}
        ]
      }, {
        category: '水果',
        description: '产地直发，海量供应',
        imageUrl: 'https://image.cnhnb.com/image/png/miniapp/2021/01/18/011c3d09cb2642d38f970ed1f7248d9c.png',
        categoryData1: [
            {
                categoryName: '热带水果',
                categoryItemList: ['芒果', '荔枝', '龙眼', '菠萝', '火龙果', '香蕉', '榴莲', '木瓜', '莲雾', '山竹'],
            },
            {
                categoryName: '浆果类',
                categoryItemList: ['葡萄', '草莓', '树莓', '圣女果', '桑葚', '蓝莓', '黑果花楸果', '猕猴桃', '柿子', '百香果'],
            },
            {
                categoryName: '核果仁果类',
                categoryItemList: ['苹果', '梨', '山楂', '沙果', '李子', '鲜枣', '杏', '杨梅', '青梅', '蜜桃'],
            }
        ],
        categoryData2: [
            {
                categoryName: '柑橘类',
                categoryItemList: ['柠檬', '柑桔', '金桔', '橙子', '柚子'],
            },
            {
                categoryName: '瓜果类',
                categoryItemList: ['西瓜', '甜瓜', '哈密瓜', '八月瓜', '火参果', '九月瓜', '地稍瓜', '泡泡果'],
            }
        ],
        goods: [{
            image: 'https://image.cnhnb.com/image/png/head/2021/06/05/7a9c3533043446bda4a2ddce42e657f2.png?imageView2/1/w/525/h/525/format/jpg/interlace/1/quality/100/ignore-error/1',
            price: '1.10',
            unit: '元/斤',
            num: '',
            goodTitle: '晓蜜25号（热销）西州蜜17号 海南产地直发',
            margin: '2000'
        }, {
            image: 'https://image.cnhnb.com/transcode/video/mp4/head/2020/06/04/f229f18cb341417babbcad5c56ac94bb.jpg?imageView2/1/w/525/h/525/format/jpg/interlace/1/quality/100/ignore-error/1',
            price: '1.10',
            unit: '元/斤',
            num: '',
            goodTitle: '胶蜜25号 产地直供小蜜25，量大优惠',
            margin: '2000'
        }],
        suppliers: [
            {'shopId': '', 'shopName': '阿伟农副产品购销中心'},
            {'shopId': '', 'shopName': '春丽生鲜'},
            {'shopId': '', 'shopName': '鲜果干货水果店'},
            {'shopId': '', 'shopName': '砀山县梓承水果经营店'},
            {'shopId': '', 'shopName': '荣生农副产品购销部'},
            {'shopId': '', 'shopName': '张晓忠的店'},
            {'shopId': '', 'shopName': '云南七彩富贵果业有限公司'}
        ]
      }],
    }
  },
  mounted () {
    this.getTypeList()
    this.getProductList()
    this.getShopList()
  },
  computed: {
    ...mapGetters([
        'searchObj',
        'homeSelectIndex'
    ])
  },
  methods: {
    ...mapMutations({
        setSearchObj: 'SET_SEARCHOBJ',
        setHomeSelectIndex: 'SET_HOMESELECTINDEX'
    }),
    async getTypeList () {
        const response = await getTypeList()
        const res = response.data
      if (res.code === '200') {
        res.data.forEach(item => {
            const id = item.id
            if (id === 1) { // 农副加工
                this.supply[2].category = item.primaryName
                this.supply[2].description = item.memo
                this.supply[2].categoryData1 = []
                this.supply[2].categoryData2 = []

                const childrenTypes = item.childrenType
                for (let i = 0; i < childrenTypes.length; i++) {
                    if (i < 3) {
                        let categoryData = {}
                        categoryData.categoryName = childrenTypes[i].bigName
                        categoryData.categoryItemList = childrenTypes[i].smallNames
                        this.supply[2].categoryData1.push(categoryData)
                    } else {
                        let categoryData = {}
                        categoryData.categoryName = childrenTypes[i].bigName
                        categoryData.categoryItemList = childrenTypes[i].smallNames
                        this.supply[2].categoryData2.push(categoryData)
                    }
                }
            } else if (id === 2) { // 粮油米面
                this.supply[1].category = item.primaryName
                this.supply[1].description = item.memo
                this.supply[1].categoryData1 = []
                this.supply[1].categoryData2 = []

                const childrenTypes = item.childrenType
                for (let i = 0; i < childrenTypes.length; i++) {
                    if (i < 3) {
                        let categoryData = {}
                        categoryData.categoryName = childrenTypes[i].bigName
                        categoryData.categoryItemList = childrenTypes[i].smallNames
                        this.supply[1].categoryData1.push(categoryData)
                    } else {
                        let categoryData = {}
                        categoryData.categoryName = childrenTypes[i].bigName
                        categoryData.categoryItemList = childrenTypes[i].smallNames
                        this.supply[1].categoryData2.push(categoryData)
                    }
                }
            }
        })
      }
    },
    async getProductList () {
      // 粮油米面
      const params = {'id': 2, 'page': 0, 'pageSize': 0}

      const response = await getProductList(params)
      const res = response.data
      if (res.code === '200') {
        const resData = res.data
        if (resData.length > 0) {
            this.supply[1].goods = []
            resData.forEach(rd => {
                this.supply[1].goods.push({
                    'image': rd.productImage,
                    'price': rd.price,
                    'unit': rd.unit,
                    'num': rd.dealAmount,
                    'goodTitle': rd.productName,
                    'margin': '',
                    'typeId': 2,
                    'productId': rd.productId,
                    'shopId': rd.shopId,
                    'skuId': rd.skuId
                })
            })
        }
      }

      // 农副加工
      const params1 = {'id': 1, 'page': 0, 'pageSize': 0}

      const response1 = await getProductList(params1)
      const res1 = response1.data
      if (res1.code === '200') {
        const resData1 = res1.data
        if (resData1.length > 0) {
            this.supply[2].goods = []
            resData1.forEach(rd => {
                this.supply[2].goods.push({
                    'image': rd.productImage,
                    'price': rd.price,
                    'unit': rd.unit,
                    'num': rd.dealAmount,
                    'goodTitle': rd.productName,
                    'margin': '',
                    'typeId': 1,
                    'productId': rd.productId,
                    'shopId': rd.shopId,
                    'skuId': rd.skuId
                })
            })
        }
      }
    },
    async getShopList () {
      // 粮油米面
      const params = {'id': 2, 'page': 0, 'pageSize': 0}
      const response = await getShopList(params)
      const res = response.data
      if (res.code === '200') {
        const resData = res.data
        if (resData.length > 0) {
            this.supply[1].suppliers = []
            resData.forEach(rd => {
                this.supply[1].suppliers.push({'shopName': rd.shopName, 'shopId': rd.shopId, 'typeId': 2})
            })
        }
      }

      // 农副加工
      const params1 = {'id': 1, 'page': 0, 'pageSize': 0}
      const response1 = await getShopList(params1)
      const res1 = response1.data
      if (res1.code === '200') {
        const resData1 = res1.data
        if (resData1.length > 0) {
            this.supply[2].suppliers = []
            resData1.forEach(rd => {
                this.supply[2].suppliers.push({'shopName': rd.shopName, 'shopId': rd.shopId, 'typeId': 1})
            })
        }
      }
    },
    // 拓展分类点击
    categoryItemClick (item) {
      this.setSearchObj({
        keyword: item,
        searchVal: '商品'
      })
      this.setHomeSelectIndex(3)
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
    // 跳转到店铺
    toStore (typeId, shopId) {
        if (typeId === 1 || typeId === 2) {
            this.$router.push({
                path: '/store', query: {shopId: shopId}
            })
        }
    },
    // 跳转到商品详情
    toProductDetail (typeId, item) {
        if (typeId === 1 || typeId === 2) {
            let data = {
                shopId: item.shopId,
                productId: item.productId,
                skuId: item.skuId
            }
            this.$router.push({
                path: '/productDetail',
                query: {
                    proData: JSON.stringify(data)
                }
            })
        }
    },
  }
}
</script>
<style lang="scss" scoped>
.root{
  width: 100%;
  padding: 15px 8vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .root-title {
    height: 84px;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 0 16px;

    color: #222;
    font-size: 18px;
    font-weight: 600;
  }
  .supply-view {
    display: flex;
    flex-direction: row;
    height: 380px;
    width: 100%;
    margin-bottom: 12px;
    border: 1px solid #e9e9e9;
    .left{
        background: #e98f8f;
        display: flex;
        flex-direction: row;
        // padding: 20px;
        .category-view {
            // background-color: #8de08e;
            height: 100%;
            width: 170px;
            display: flex;
            flex-direction: column;
            .title {
                height: 30px;
                border-left: 6px solid #127614;
                margin:  20px 0 12px 0;
                padding-left:16px;

                color: #127614;
                font-size: 20px;
                font-weight: 600;

                display: flex;
                align-items: center;
            }
            .subTitle {
                width: 100%;
                padding-left: 22px;
                color: #127614;
                font-size: 12px;
            }
        }
        .category-view-info {
            width: 100%;
            display: flex;
            flex-direction: row;

            .info-row-1,.info-row-2{
                // height: 100%;
                width: 50%;
                background-color: #fff;
                padding: 20px 10px;
                box-sizing: border-box;
                .left-category {
                    margin-bottom: 25px;
                    // background-color: #e260bd;
                    display: flex;
                    flex-direction: column;
                    .category-name {
                        display: flex;
                        .name {
                            height: 100%;
                            font-size: 15px;
                            color: #333333;
                            font-weight: 600;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            &:hover{
                                color: #39bf3e;
                                background-color: #F5F5F5;
                            }
                        }
                    }
                    .category-row {
                        display: flex;
                        overflow-x: hidden; //超出隐藏
                        flex-wrap: wrap;
                        // margin-bottom: 20px;
                        margin-top: 10px;
                        li {
                            // background-color: #fff;
                            display: inline-block;
                            margin-right: 10px;
                            margin-bottom: 12px;
                            display: flex;
                                h4{
                                    font-size: 12px;
                                    color: #666666;
                                    cursor: pointer;
                                    &:hover{
                                        color: #39bf3e;
                                        background-color: #F5F5F5;
                                    }
                                }
                        }
                    }
                }
            }
        }
        .left-title-view {
            height: 80px;
            background-color: #fff;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
            .left-title {
                display: flex;
                font-size: 18px;
                color: #333333;
                font-weight: 500;
            }
            .left-more {
                display: flex;
                flex-direction: row;
                font-size: 12px;
                color: #666666;
            }
        }
        .left-table-view {
            width: 100%;
        }

    }
    .right{
        background: #20ab22;
        display: flex;
        flex-direction: row;
        .right-view-left {
            background: #fff;
            height: 100%;
            padding: 0px 5px;
            .title {
                border-left: 4px solid #127614;
                margin:  20px 0 12px 0;
                padding-left:10px;

                color: #333;
                font-size: 14px;
                font-weight: 500;

                display: flex;
                align-items: center;
            }
            .goods-view {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .goods {
                    display: flex;
                    flex-direction: column;
                    margin-left: 5px;
                    cursor: pointer;
                    img{
                        margin-right: 8px;
                        width: 160px;
                        height: 160px;
                    }
                    .price-view {
                        margin-top: 20px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        .price {
                            color: red;
                            font-size: 16px;
                        }
                        .price-unit {
                            margin-left: 5px;
                            color: red;
                            font-size: 12px;
                        }
                        .num {
                            margin-left: 10px;
                            color: #666;
                            font-size: 12px;
                        }
                    }
                    .goodTitle {
                        margin-right: 8px;
                        margin-top: 12px;
                        color: #333;
                        font-size: 12px;
                    }
                    .margin {
                        width: 100px;
                        margin-top: 5px;
                        padding: 6;
                        font-size: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 18px;
                        font-family: PingFangSC-Regular;
                        font-size: 11px;
                        display: flex;
                        flex: none;
                        align-items: center;
                        background: #eff4fb;
                        border: 1px solid #8a9fcc;
                        color: #4869af;
                        border-radius: 4px;
                    }
                    .vip {
                        width: 100px;
                        margin-top: 5px;
                        padding: 8;
                        border-radius: 4px;
                        // color: #c6b90f;
                        // background: #f5f772;
                        font-size: 12px;
                        // border:1px solid #f5f772;
                        display: flex;
                        align-items: center;
                        justify-content: left;

                    }

                }
            }
        }
        .right-view-right {
            background: #fff;
            height: 100%;
            padding: 0px 5px 0px 0px;
            .title {
                border-left: 4px solid #127614;
                margin:  20px 0 12px 0;
                padding-left:10px;

                color: #333;
                font-size: 14px;
                font-weight: 500;

                display: flex;
                align-items: center;
            }
            .supplier-view {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 20px;

                .dot {
                    width: 4px;
                    height: 4px;
                    border-radius: 2;
                    margin-right: 8px;
                    background-color: #666;
                }
                .supplier{
                    color: #666;
                    font-size: 12px;
                    cursor: pointer;
                    &:hover{
                        color: #39bf3e;
                        background-color: #F5F5F5;
                    }
                }
            }

        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/supply.vue